import React from "react";

const ProductSkeleton = ({ view, isMobile, showFilters }) => {
  const skeletonStyle = {
    backgroundColor: "#e5e7eb",
    borderRadius: "8px",
    animation: "shimmer 2s infinite",
    backgroundImage: "linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite"
  };

  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      <div
        className={
          view === "grid"
            ? (!isMobile && showFilters ? "col-sm-6 col-lg-4" : "col-sm-6 col-lg-3")
            : "col-12"
        }
      >
        <div
          className={`card border-0 shadow-sm rounded-4 overflow-hidden position-relative h-100 ${view === "list" && !isMobile ? "flex-row" : ""}`}
          style={{ border: "1px solid #e5e7eb" }}
        >
          {/* Skeleton Image */}
          <div
            style={{
              width: view === "list" && !isMobile ? "clamp(200px, 30%, 280px)" : "100%",
              height: "auto",
              aspectRatio: view === "list" && !isMobile ? "auto" : "3 / 2",
              ...skeletonStyle,
              flexShrink: 0
            }}
          />

          {/* Skeleton Body */}
          <div className="card-body p-4 d-flex flex-column" style={{ flex: 1 }}>
            {/* Title Skeleton */}
            <div style={{ ...skeletonStyle, height: "20px", marginBottom: "12px", width: "70%" }} />

            {/* Business Name Skeleton */}
            <div style={{ ...skeletonStyle, height: "14px", marginBottom: "12px", width: "50%" }} />

            {/* Location Skeleton */}
            <div style={{ ...skeletonStyle, height: "12px", marginBottom: "16px", width: "60%" }} />

            {/* Specs Skeleton */}
            <div
              className="row g-2 mb-3 mt-1 border-top pt-3"
              style={{ borderTop: "1px solid #e5e7eb" }}
            >
              <div className="col-12 col-sm-6">
                <div style={{ ...skeletonStyle, height: "12px", marginBottom: "8px" }} />
                <div style={{ ...skeletonStyle, height: "12px" }} />
              </div>
              <div className="col-12 col-sm-6">
                <div style={{ ...skeletonStyle, height: "12px", marginBottom: "8px" }} />
                <div style={{ ...skeletonStyle, height: "12px" }} />
              </div>
            </div>

            {/* Footer Skeleton */}
            <div
              className="mt-auto pt-3 d-flex justify-content-between align-items-center border-top gap-2"
              style={{ borderTop: "1px solid #e5e7eb" }}
            >
              <div style={{ ...skeletonStyle, height: "16px", width: "80px" }} />
              <div style={{ ...skeletonStyle, height: "36px", width: "60px", borderRadius: "8px" }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductSkeleton;
